<template>
    <div>
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>

      <sub-head-form :formSchema="formSchema" @reloadData="close"></sub-head-form>
              <!-- Confirmation delete box -->
        <v-layout row justify-center>
            <v-dialog v-model="confirmModel" max-width="290">
                <v-card>
                    <v-card-text>Are you sure you want to delete this data?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">
                            Agree
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <!-- /Confirmation delete box -->
     <v-container>
 <v-card>
    <v-card-title>
	<span class="headline">Administrative Leave Entry List</span>
      &nbsp;&nbsp;&nbsp;
      <v-btn title="View Details" icon class="mx-0" @click="viewCalendar()">
                <v-icon color="teal">event</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"      
    >
    <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ ++(props.index) }}</td>
            <td class="text-xs-left">{{ props.item.staff_name }}</td>
            <td class="text-xs-left">{{ props.item.leave_type_name }}</td>
            <td class="text-xs-left">{{ props.item.leave_purpose }}</td>
            <td class="text-xs-left">{{ props.item.leave_contact_address }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.from_date) }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.to_date) }}</td>
            <td>
              <span v-if="props.item.is_station_leave" class="active">Yes</span>
              <span v-else class="in-active">No</span>
            </td>
            <td class="justify-center layout px-0">
            <v-btn title="View Details" icon class="mx-0" @click="viewDetails(props.item.id)">
                <v-icon color="teal">view_module</v-icon>
              </v-btn>
                <v-btn icon class="mx-0"  @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
                    <v-icon color="pink">delete</v-icon>
                </v-btn>
            </td>

        </template> 

       <template slot="no-data" class="error">
       <div align="center"> No Data Found</div>
    </template>
    </v-data-table>
      <!-- <v-data-table item-key="name" class="elevation-1" loading loading-text="Loading... Please wait"></!--> 
  </v-card>
     </v-container>
     
    </div>
</template>
<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import subHeadForm from './leave_form'
import Axios from 'axios'
export default {
    components:{
        subHeadForm
    },
    data: () => ({
      showForm : false,
      valid: true,
      dialog: false,
      dialogEditForm:false,

      search: '',
      totalItems: 0,      
      loading: true,

      pagination: {
        sortBy: 'id',
        descending:true,
      },
      
      selected:[],
      search:'',      
      headers: [
      {
        text: 'Sl#',
        align: 'left',
        sortable: false,
        value: 'id'
      },
      {
        text: 'Staff',
        align: 'left',
        sortable: false,
        value: 'staff_name'
      },
      { text: 'Leave Type', align: 'left', value: 'leave_type' },
      { text: 'Leave Purpose', align: 'left', value: 'leave_purpose' },
      { text: 'Leave Address', align: 'left', value: 'leave_contact_address' },
      { text: 'From Date', align: 'left', value: 'from_date' },
      { text: 'To Date', align: 'left', value: 'to_date' },
      { text: 'Station Leave', value: '	is_station_leave' },
      { text: 'Actions', value: '', align:'center' }

      
      ],
      items: [],
      
       formSchema:{
          id:'',
          user_id:'',
          staff_name:'',
          leave_type:'',
          leave_purpose:'',
          is_station_leave:'',
          leave_contact_address:'',
          from_date:'',
          to_date:'' ,
          active: '',
          
      },
      delete_id:'',
      row_index:'',
      dialog2: false,
      snackbar: false,
      color: 'success',
      mode: '',
      timeout: 3000,
      left:'left',
      message: '',
      confirmModel: false,
      select: null,
      adminTypelist:[
        {id:1, name:'DIA'},
        {id:3, name:'Institute'},
      ],

       SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
      instituteShow:true,
    }),

    computed: {
      userRole() {
                let role = this.$store.getters.get_USER_ROLE_DATA;               
                this.showForm = role.saveButton
                return role;
            }
    },

    methods: {
     viewDetails(item)
      {
        sessionStorage.setItem("leaveInfoId", item); 
        this.$router.push('/administration/personal-leave-tracking');
        console.log(item)
      },
      viewCalendar()
      {
        
        this.$router.push('/administration/leave-tracking-calendar');
        
      },
     getDataFromApi(){  

      commonService.getAllData('leave-management').then(res => {                                    
        this.items = res.data;
        this.loading = false;
      });

      },

       changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },

      validateBeforeSubmit(e) {

      },
      reloadData(){
        this.showForm = this.userRole.saveButton;
        this.getDataFromApi()
        this.message = 'Data reloaded successfully!'
        this.snackbar = true
      
      },

      editItem (item) {
         item.from_date = this.changeFormateDMY(
          item.from_date
          );
      
        item.to_date = this.changeFormateDMY(
          item.to_date
          );
        this.formSchema = item;

        this.showForm = true
        window.scrollTo({ // scroling to top
			    top: 0,
			    left: 100,
			    behavior: "smooth"
			  });
      },

      deleteItem (index,id) {          
        this.row_index = index;
        this.delete_id = id;                
        this.confirmModel = true;
      },

      confirmDelete(row_index,id){                    
        commonService.deleteRow(id, 'leave-management').then(res => {
              if (res.status == 1) {
            this.items.splice(row_index, 1);
            this.getDataFromApi();
          } else {
            this.SnackbarVal.color = "error";
          }
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;

          this.confirmModel = false;
          this.dialog2 = false;
        
        });       
      },
      close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.items.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          let findindex = this.items.findIndex(
            (item) => item.id == res.data.id
          );
          this.row_index = findindex;
          this.$set(this.items, this.row_index, { ...res.data });
          this.row_index = "";
          this.formSchema.id = 0;
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }
     
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    },

    },

    mounted () {
      this.getDataFromApi();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/administration/leave_entry/leave_entry_list.vue